import React from 'react';
import { Handle, Position } from 'reactflow';

const SitemapNode = ({ data }) => {
  const nodeStyles = "relative bg-white border-2 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-200 w-[300px]";
  const headerStyles = "px-4 py-2 font-semibold text-white rounded-t-md";
  const sectionStyles = "mt-2 p-2 bg-gray-100 rounded-lg text-sm";

  const bgColors = {
    main: "bg-gray-900 border-gray-900",
    section: "bg-gray-800 border-gray-800",
    screen: "bg-gray-700 border-gray-700",
  };

  return (
    <div className={`${nodeStyles} ${bgColors[data.type] || "border-gray-300"}`}>
      <Handle type="target" position={Position.Top} />
      <div className={`${headerStyles} ${bgColors[data.type]}`}>
        {data.label}
        <span className="ml-2 text-xs px-2 py-1 bg-white text-gray-900 rounded-md">
          {data.type}
        </span>
      </div>
      <div className="p-3 bg-gray-50">
        <div className="text-gray-700">{data.description}</div>

        {data.specifications && (
          <div className={sectionStyles}>
            <h4 className="font-semibold text-gray-800">Specifications</h4>
            <ul className="list-disc list-inside text-gray-600">
              {Object.entries(data.specifications).map(([key, value]) => (
                <li key={key}>
                  <strong>{key}:</strong>{" "}
                  {typeof value === "string" ? (
                    value
                  ) : (
                    <ul className="list-circle ml-4">
                      {Array.isArray(value)
                        ? value.map((item, index) => (
                            <li key={index}>{item}</li>
                          ))
                        : Object.entries(value).map(([subKey, subValue]) => (
                            <li key={subKey}>
                              <strong>{subKey}:</strong>{" "}
                              {Array.isArray(subValue) ? (
                                <ul className="list-disc ml-6">
                                  {subValue.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                  ))}
                                </ul>
                              ) : (
                                subValue
                              )}
                            </li>
                          ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}

        {data.wireframe && (
          <div className={sectionStyles}>
            <h4 className="font-semibold text-gray-800">Wireframe</h4>
            <p className="text-gray-600">{data.wireframe}</p>
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
};

export default SitemapNode; 